import React, { FC, HTMLAttributes, ReactNode } from 'react';
import classNames from 'classnames';
import { Button, StatusBadge } from 'components/ui';
import { AppStatus } from '../../constants';
import { t } from 'utils';
import styles from './Subscribe.module.scss';

export interface ISubscribe extends HTMLAttributes<HTMLDivElement> {
  status: AppStatus;
}

const Subscribe: FC<ISubscribe> = (props) => {
  const { status, className } = props;
  const rootClassName = classNames(styles.root, className);

  let content: ReactNode = (
    <div>
      <p className={classNames('my-3', styles.text)}>
        {t('app.status.pending.authoriseCountHint')}
      </p>
      <p className={classNames('mb-3', styles.text)}>{t('app.status.developerNotice')}</p>
      <Button id='indercomChat' type='button' inline>
        {t('apply.to.become.a.partner')}
      </Button>
    </div>
  );

  if (status === 'APPROVED') {
    content = (
      <div>
        <p className={classNames('mt-3', styles.text)}>
          {t('app.preview.settings.appAction.publish')}
        </p>
      </div>
    );
  }

  if (['PUBLISHED', 'DECLINED', 'PENDING'].includes(status)) {
    content = null;
  }

  return (
    <section className={rootClassName}>
      <p className={styles.title}>{t('app.preview.settings.appStatus')}</p>
      <StatusBadge className={styles.badge} status={status} />
      {content}
    </section>
  );
};

export default Subscribe;
